<template>
  <div class="content">
    <div class="box">
        <div class="box-body">
            <div class="form-group">
                <router-link :to="{path: '/addAnnouncement'}">
                    <div class="btn btn-default btn-table-title">新增公告</div>
                </router-link>
                <div v-if="!isDeleteStatus" class="btn btn-default btn-table-title" @click="isDeleteStatus = true">批次刪除</div>
                <div v-if="isDeleteStatus" class="btn btn-default btn-table-title" @click="isDeleteStatus = false">取消</div>
                <button v-if="isDeleteStatus" class="btn btn-danger" data-toggle="modal" data-target="#delNewsModal" @click="deleteAnnouncement">刪除</button>
            </div>
            <div class="table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                        <tr role="row">
                            <th v-if="isDeleteStatus" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">序號</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">標題</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">蓋板公告</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">發布對象</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">發布時間</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">最後編輯時機</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">最後編輯編輯者</th>
                            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                        </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr>
                        <td colspan="12" class="text-center">資料讀取中......</td>
                      </tr>
                    </tbody>
                    <tbody v-else-if="!isLoading && announcementList.length > 0">
                        <tr v-for="(news, index) in announcementList" :key="index" class="even" role="row">
                            <td v-if="isDeleteStatus">
                               <input type="checkbox" v-model="news.selectItem"/>
                            </td>
                            <td class="sorting_1">
                                {{index + 1 }}
                            </td>
                            <td style="width: 200px">
                                {{news.title}}
                            </td>
                            <td>
                                <span :class="['label', news.is_overlay?'label-success':'label label-danger']">{{news.is_overlay?'啟用':'不啟用'}}</span>
                            </td>
                            <td>
                                {{news.role_type | roleType}}
                            </td>
                            <td>
                                {{news.announce_time}}
                            </td>
                            <td>
                                {{news.update_time}}
                            </td>
                            <td>
                                {{news.user_account}}
                            </td>
                            <td>
                                <router-link :to="{path: '/editAnnouncement/' + news.announcement_id}">
                                    <button class="btn btn-default"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                </router-link>
                                <button class="btn btn-default" data-toggle="modal" data-target="#delNewsModal" @click="deleteSingleAnnouncement(news.announcement_id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="!isLoading && announcementList.length === 0">
                      <tr style="background-color: white">
                        <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                          <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                          <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                        </td>
                      </tr>
                    </tbody>

                </table>
            </div>
            <paginate
              :pageAmount="pageAmount"
              :total="total"
              :isActive="isActive"
              :groupAmount="groupAmount"
              :clickPage="clickPage"
            />
        </div>
    </div>
    <m-modal :option="delDesAlisOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
  import matcherModal from '@/components/elements/Modal.vue'
  export default {
    name: 'News',
    components: {
      'm-modal': matcherModal
    },
    data () {
      return {
        total: 84,
        count: 10,
        tableIndex: 1,
        pageGroup: 1,
        groupAmount: 10,
        announcementList: [],
        isDeleteStatus: false,
        delDesAlisOption: {
          id: 'delNewsModal',
          title: '確認刪除此公告',
          body: '',
          btns: [
            {
              name: '取消'
            },
            {
              name: '確定',
              event: 'deleteBatchNews'
            }
          ]
        },
        deleteId: null,
        isLoading: true
      }
    },
    filters: {
      roleType: (val) => {
        switch (val) {
          case 0:
            return '不限'
          case 1:
            return 'Admin'
          case 2:
            return 'Brand'
          case 3:
            return 'Store'
        }
      }
    },
    computed: {
      pageAmount () {
        return Math.ceil(this.total / this.count)
      },
      getDataH () {
        return this.$parent.getDataH
      }
    },
    created () {
      this.getList()
    },
    methods: {
      clickPage (index) {
        this.tableIndex = index
        this.getList()
      },
      isActive (index) {
        if (this.tableIndex === index) return true
        else return false
      },
      trigger (event) {
        if (!event) {
          return
        } else if (event === 'deleteBatchNews') {
          this.deleteNews('batch')
        } else {
          this.deleteNews('single')
        }
      },
      deleteAnnouncement () {
        this.delDesAlisOption.btns[1].event = 'deleteBatchNews'
      },
      deleteNews (type) {
        let deleteQuery = ''
        if (type === 'batch') {
          const deleteItems = this.announcementList.filter(x => x.selectItem).map(x => x.announcement_id)
          deleteQuery = deleteItems.toString()
        } else {
          deleteQuery = this.deleteId
        }
        const url = 'announcement?announcement_ids=' + deleteQuery
        this.getDataH('delete', url, null, (response) => {
          this.tableIndex = 1
          this.getList()
        })
      },
      deleteSingleAnnouncement (id) {
        this.deleteId = id
        this.delDesAlisOption.btns[1].event = 'deleteSingleAnnouncement'
      },
      getList () {
        this.isLoading = true
        const url = 'announcement/list?page=' + this.tableIndex + '&size=' + this.count
        this.getDataH('get', url, null, (response) => {
          this.announcementList = response.data.announcement_list
          this.total = response.data.total
          this.isLoading = false
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?75dfb69a